import React, { Component } from 'react';
import {Link, Redirect} from "react-router-dom";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import SVG from "react-svg";
import { Translate, withLocalize } from 'react-localize-redux';

import closeImg from "../images/x.svg";
import icon from '../images/orientation-arrow.png';
import Script from 'react-load-script'


class UnlockModal extends Component {

  constructor(props){
    super(props);

    this.unlock = this.unlock.bind(this);
    this.lock = this.lock.bind(this);
  }

  unlock(){
    let { dispatch } = this.props;
    dispatch({
      type: "navigation/UNLOCK"
    });
  }

  lock(){
    let { dispatch } = this.props;
    dispatch({
      type: "navigation/LOCK"
    });
  }

  handleScriptLoad(){


    setTimeout(()=>{
    // Vanilla
    let mkt_obj={
      form_type:"",
      lang:"en",
      form_id:"5332",
      landing_id:"66391",
      cid_id:"7010d000000mWn2",
      cms_hold:"default",
      action:"inline",
      url:"#",
      target:"",
      button: this.props.translate('unlockModalContinue'),
      clean:"enable",
      post_id:"13697",
      trans:"",
      script_load:"",
      script_ready:()=>{},
      script_submit: this.unlock,
      gdpr_add_msg:"",
      gdpr_attr:"",
      gdpr_val:""
    };

      if(RequestForm) { // eslint-disable-line no-undef
        RequestForm(mkt_obj); // eslint-disable-line no-undef
      } else {
        alert('Marketo form not found.')
      }
    }, 200)


  }

  render() {

    let { navigation, location } = this.props;

    if (!navigation.unlocked) {
      return (
        <div className="unlock-modal_wrapper">
          <div className="copy-section">
            <img className="orientation-logo" src={icon} />
            <h2><Translate id="unlockModalTitle" /></h2>
            <p><Translate id="unlockModalCopy" /></p>
          </div>
          <div className="form-section">
            <div id="gmkto_form" className="gmkto_form gmkto_form_wp290 gmkto_format_vertical gmkto_brand_resource">
            <Script
                url="https://www.genesys.com/wp-content/plugins/genesys-hook-marketo/external/RequestFormExternal.js"
                onLoad={this.handleScriptLoad.bind(this)}
            />
            <form id="mktoForm_5332" className="mktoForm form29">
              <div id="known_person" style={{display: "none"}}><p className="welcome_user"><span id="welcome_person"><Translate id="unlockModalWelcomeBack" /></span>&nbsp;
                <span id="person_info"><span className="person_first"></span>&nbsp;<span className="person_last"></span></span>
              </p><p className="delete_button"><a className="deletemyrecord"><Translate id="unlockModalNotYou" /></a></p></div>
            </form>
            </div>
          </div>

          <Link className="close" to={{ pathname: "/", search: this.props.location.search }}>
            <button className="close-button" onClick={this.closeOrientation} ><SVG src={closeImg} /></button>
          </Link>

        </div>
      );
    }

    return (
      <Redirect to={{
        pathname: location.pathname.replace("/unlock", ""),
        search: location.search
      }} />
    );

  }
}

function mapStateToProps(state) {
  return {
    navigation: state.navigation,
    scene: state.scene
  }
}


export default withLocalize(withRouter(connect(mapStateToProps)(UnlockModal)));



// WEBPACK FOOTER //
// ./src/components/UnlockModal.jsx